import getEquipments from '../../api/deals/getEquipments';
import Select from '../Select/Select';
import usePaginatedSelect from '../../hooks/usePaginatedSelect';

const fetchFn = (page) => getEquipments({ page });
const extractItems = (res) => res.data.equipments;
const formatOption = (item) => ({ value: item.id, label: item.title });

const SelectEquipments = ({ handleSetSelect, handleSetState, style, ...props }) => {
  const { data, isLoading, loadMore } = usePaginatedSelect({ fetchFn, extractItems, formatOption });

  return (
    <Select
      handleSetSelect={(val) => handleSetSelect && handleSetSelect(val)}
      handleSetState={handleSetState}
      options={data}
      title={'Оборудование'}
      placeholder={'Выберите из списка'}
      onFocus={loadMore}
      style={style}
      isLoading={isLoading}
      isMulti
      isSearchable
      {...props}
    />
  );
};

export default SelectEquipments;
